import { useState, useEffect } from 'react';

interface WindowType {
  width: number;
  height: number;
}

// Window size hook
function useWindowSize() {
  const [windowSize, setWindowSize] = useState<WindowType>({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const { innerHeight, innerWidth } = window;
      const handleResize = () => {
        setWindowSize({
          width: innerWidth,
          height: innerHeight,
        });
      };

      window.addEventListener('resize', handleResize);

      handleResize();

      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);
  return windowSize;
}

export default useWindowSize;
